import React from "react";
import "./footer.css";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <img src={logo} alt="logo" className="footer__logo" />
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About Me
            </a>
          </li>
          <li>
            <a href="#skills" className="footer__link">
              Skills
            </a>
          </li>
          <li>
            <a href="#portfolio" className="footer__link">
              Portfolio
            </a>
          </li>
          {/* <li>
            <a href="#experiences" className="footer__link">
              Employment Records
            </a>
          </li> */}
          <li>
            <a href="#accreditations" className="footer__link">
              Accreditations
            </a>
          </li>
        </ul>
        <div className="footer__social">
          <a
            href="https://www.linkedin.com/in/visaludam/"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-linkedin"></i>
          </a>
          <a
            href="https://www.github.com/visaludam"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-github"></i>
          </a>
          <a
            href="https://www.behance.com/visaludam"
            className="footer__social-link"
            target="_blank"
            rel="noreferrer"
          >
            <i class="bx bxl-dribbble"></i>
          </a>
        </div>
        <span className="footer__copy"> &#169; Visal, All rights reserved</span>
      </div>
    </footer>
  );
};

export default Footer;
